export const industryEndpoints = {
  getAll: "/industry",
  getIndustriesById: (id) => `/industry/${id}`,
};
